import React from "react";

export const Description = () => {
  return (
    <div className="bg-slate-200 rounded p-3 w-[97%] md:w-[99%] lg:w[100%] ">
      <h3 className="font-bold mb-2">
        33,287 watching now Started straming 73 minues ago
      </h3>
      <p className="mb-2">
        Live: MI Vs PBKS, Match 31, Mumbai | CRICTALKS | IPL LIVE 2023 | Mumbai
        Indians Vs Punjab Kings
      </p>
      <p className="mb-2">
        For queries: anatomizedtube@gmail.com PREVIEW: Mumbai Indians (MI) are
        set to play with Punjab Kings (PBKS) in the ongoing Indian Premier
        League (IPL). MI are on a roll, winning three games on the bounce, while
        PBKS are coming from a defeat against RCB in their last game. PBKS will
        look to bounce back, while MI would be hoping to keep the winning run
        going. With three wins, MI are up and running in IPL 2023 season. The
        main cause for this resurgence is the form of their young players like
        Tilak Varma, Cameron Green, Riley Meredith and Ishan Kishan. These
        players have stepped in admirably and have lifted the responsibility on
        senior players Rohit and Suryakumar Yadav. The former also got back to
        form with a fifty, while the latter is still struggling for runs. MI
        bowlers have also kept things tight, with Piyush Chawla leading the
        lineup. As for PBKS, the team has struggled in the batting without their
        regular captain Shikhar Dhawan. The left has missed three games, and it
        is still not clear when he will be fit. With Liam Livingstone back, PBKS
        would expect the middle-order issues will be sorted. Matthew Short
        hasn't got going and Sikandar Raza is likely to come in place. The match
        will be played at Wankhede Stadium in Mumbai. It is a batting surface,
        with short boundaries on either side. It is a bat second ground, with
        170 being the average score.
      </p>
    </div>
  );
};
